import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import straw from "./components/straw";
import wood from "./components/wood";
import hemp from "./components/hemp";
import recycledTextile from "./components/recycled-textile";

const principle: Slide = {
  description:
    "This section presents some frequently used bio-based materials, their acoustic properties and points of application in buildings. Acoustic properties are colour-coded: blue indicates porous absorptive materials, orange denotes materials which add mass to light-weight partitions, and green marks the materials used in coat finishing and applications that require airtightness.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Straw" }, { name: "Wood" }, { name: "Hemp" }, { name: "Recycled textile" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], []],
      components: [straw, wood, hemp, recycledTextile],
    },
  },
};

export default principle;
